module.exports = __webpack_public_path__ + "static/media/9DESA2.25a6e443.jpg";